import React from "react";
import { BiCloudDownload } from "react-icons/bi";
import { IoAddCircle } from "react-icons/io5";
import { MdOutlineCreateNewFolder } from "react-icons/md";
import { ThreeDots } from "react-loader-spinner";
import { ProtocolsIcon } from "src/assets/static/icons";
import MutableIcon from "src/components/mutable-icon";
import SideListView from "src/components/SideListView";

import { useStudent } from "src/contexts/student";
import { ProtocolLI } from "src/modules/fithub-shared/interfaces/protocol";
import api from "src/rest/api";
import { LoadProtocol } from "../../cache/protocol-manager";
import { usePlan } from "../../context";
import ProtocolsList from "./protocols-listing";
import { HeaderButton } from "./protocols-listing/styles";
import ProtocolView from "./ProtocolView";
// import { Container } from './styles';

interface PlanViewProps {
  student?: string;
  list?: ProtocolLI[];
  loadingList: boolean;
  isTemplates: boolean;
  handleRemoveProtocol(id: string, callback: () => void): void;
  handleDuplicate(id: string): void;
  handleSaveTemplate(id: string): void;
  handleExport(id: string): void;
  handleImport(): void;
}

const View: React.FC<PlanViewProps> = (props) => {
  const { plan, reloadList } = usePlan();

  const { student } = useStudent();

  function handleChangeTitle(t: string) {
    if (plan.selected === null) return;

    const nplan = { ...plan.selected };
    nplan.title = t;
    plan.update(nplan);
  }

  function handleChangeObs(t: string) {
    if (plan.selected === null) return;
    const nplan = { ...plan.selected };
    nplan.obs = t;
    plan.update(nplan);
  }

  function handleRemoveProtocol(id: string) {
    props.handleRemoveProtocol(id, plan.unselect);
  }

  async function CreateProtocolTemplate() {
    await api
      .post("/protocols/create", {
        studentid: props.isTemplates ? null : student?.id,
      })
      .then(reloadList)
      .catch((err) => {
        alert(
          "Não foi possivel criar protocolo: Função Indisponível! - " + err,
        );
      });
  }

  function onLoadProtocol(id: string) {
    if (plan.selected?.id === id) {
      plan.setProtocol(null);
      return;
    }

    LoadProtocol(id).then((res) => plan.setProtocol(res));
  }

  return (
    <SideListView
      onGoBack={plan.unselect}
      view={plan.selected ? "CONTENT" : "LIST"}
      content={
        <ProtocolView
          callbacks={{
            onChangeTitle: handleChangeTitle,
            onChangeObs: handleChangeObs,
            onDelete: handleRemoveProtocol,
            onDuplicate: props.handleDuplicate,
            onSaveTemplate: props.handleSaveTemplate,
            onExport: props.handleExport,
          }}
        />
      }
      list={
        <div className="flex h-full w-full flex-col">
          {props.isTemplates ? (
            <div className="flex items-center p-2">
              <ProtocolsIcon
                style={{
                  backgroundColor: "#ddd",
                  borderRadius: "50%",
                  padding: 10,
                  marginRight: 10,
                }}
                color="#666"
                size={48}
              />
              <div className="flex flex-1">
                <h1 className="font-bold uppercase">Protocolos Template</h1>
              </div>
              <button
                onClick={CreateProtocolTemplate}
                className="flex items-center gap-2 rounded-full bg-primary-500 p-1.5 text-white"
              >
                <IoAddCircle color="white" />
                <p className="text-sm font-bold">CRIAR</p>
              </button>
            </div>
          ) : (
            <div className="p-2 dark:text-white">
              <h2>Protocolos do Aluno</h2>
            </div>
          )}

          {!props.isTemplates && (
            <div className="flex" style={{ paddingInline: 5 }}>
              <HeaderButton onClick={CreateProtocolTemplate}>
                <MutableIcon icon={MdOutlineCreateNewFolder} size={24} />
                <p>Criar</p>
              </HeaderButton>
              <span style={{ margin: 2.5 }} />
              <HeaderButton onClick={props.handleImport}>
                <MutableIcon icon={BiCloudDownload} size={24} />
                <p>Importar</p>
              </HeaderButton>
            </div>
          )}
          {props.loadingList ? (
            <div className="hfcentered flex">
              <ThreeDots
                height="60"
                width="60"
                color="#000"
                ariaLabel="three-dots-loading"
                visible={true}
              />
            </div>
          ) : (
            <ProtocolsList
              list={props.list ?? []}
              selected={plan.selected ?? undefined}
              templates={props.isTemplates}
              onUpdateList={reloadList}
              onSetSelected={onLoadProtocol}
              onUnselect={plan.unselect}
              onDelete={handleRemoveProtocol}
              onDuplicate={props.handleDuplicate}
              onSaveTemplate={props.handleSaveTemplate}
              onExport={props.handleExport}
            />
          )}
        </div>
      }
    />
  );
};

export default View;
